// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1x7SU","resendInfoText":"OnGoingPaymentBox_resendInfoText__1MhLT"};